'use client';

import { useMediaQuery } from './use-media-query.mjs';
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight) return "light";
  if (isDark) return "dark";
  return void 0;
}
export { useColorModePreference, usePrefersReducedMotion };